<template>
  <div class="gen-tool">
    <div class="gen-input-section">
      <div class="gen-input-label">
        <span class="gen-dot" />
        {{ $t('tool.Generator.desc') }}
      </div>

      <!-- 第一行：长度 -->
      <div class="gen-row">
        <div class="gen-field gen-field-length">
          <label>{{ $t('tool.Generator.lenLabel') }} <span class="gen-hint">{{ $t('tool.Generator.lenHint') }}</span></label>
          <div class="gen-length-row">
            <el-input-number v-model="length" :min="4" :max="512" size="small" @change="generate" class="gen-len-input" />
            <el-slider v-model="length" :min="4" :max="512" :step="1" @change="generate" class="gen-slider" />
            <div class="gen-presets">
              <el-button v-for="p in presets" :key="p" size="mini" :type="length===p?'primary':'plain'" @click="length=p; generate()">{{ p }}</el-button>
            </div>
          </div>
        </div>
      </div>

      <!-- 第二行：数量 + 字符集 + 生成 -->
      <div class="gen-row gen-row-3">
        <div class="gen-field">
          <label>{{ $t('tool.Generator.countLabel', { n: count }) }}</label>
          <el-input-number v-model="count" :min="1" :max="512" size="small" @change="generate" style="width:100%" />
        </div>
        <div class="gen-field">
          <label>{{ $t('tool.Generator.charsetLabel') }}</label>
          <el-select v-model="charset" size="small" style="width:100%;" @change="generate">
            <el-option :label="$t('tool.Generator.charsetAlphanum')" value="alphanum" />
            <el-option :label="$t('tool.Generator.charsetAll')" value="all" />
            <el-option :label="$t('tool.Generator.charsetUpper')" value="upper" />
            <el-option :label="$t('tool.Generator.charsetLower')" value="lower" />
            <el-option :label="$t('tool.Generator.charsetDigits')" value="digits" />
            <el-option :label="$t('tool.Generator.charsetHex')" value="hex" />
          </el-select>
        </div>
        <div class="gen-field gen-field-btn">
          <label>&nbsp;</label>
          <el-button type="primary" size="small" icon="el-icon-refresh" @click="generate" style="width:100%;">{{ $t("common.action.generate") }}</el-button>
        </div>
      </div>
    </div>

    <div class="gen-output" v-if="outputs.length">
      <div class="gen-output-bar">
        <span class="gen-output-label">{{ $t('tool.Generator.resultLabel', { n: outputs.length }) }}</span>
        <el-button size="mini" plain icon="el-icon-document-copy" @click="copyAll">{{ $t('tool.Generator.copyAll') }}</el-button>
      </div>
      <div class="gen-output-list">
        <div v-for="(s, i) in outputs" :key="i" class="gen-output-row" @click="copyOne(s)">
          <span class="gen-output-num">{{ i + 1 }}</span>
          <code class="gen-output-text">{{ s }}</code>
          <el-button size="mini" plain icon="el-icon-document-copy" class="gen-copy-btn">{{ $t("common.action.copy") }}</el-button>
        </div>
      </div>
    </div>

    <div class="gen-empty" v-else>{{ $t('tool.Generator.empty') }}</div>
  </div>
</template>

<script>
var CHARSETS = {
  upper:'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  lower:'abcdefghijklmnopqrstuvwxyz',
  digits:'0123456789',
  symbols:'!@#$%^&*()-_=+[]{}|;:,.<>?'
}

export default {
  name:'Generator',
  props:{ config:{ type:Object, default:function(){ return {} } } },
  data:function(){
    return { length:16, count:1, charset:'all', outputs:[], presets:[8, 16, 32, 64, 128, 256] }
  },
  created:function(){ this.generate() },
  methods:{
    generate:function(){
      var pool
      switch (this.charset) {
        case 'alphanum': pool = CHARSETS.upper + CHARSETS.lower + CHARSETS.digits; break
        case 'all': pool = CHARSETS.upper + CHARSETS.lower + CHARSETS.digits + CHARSETS.symbols; break
        case 'upper': pool = CHARSETS.upper; break
        case 'lower': pool = CHARSETS.lower; break
        case 'digits': pool = CHARSETS.digits; break
        case 'hex': pool = CHARSETS.digits + 'ABCDEF'; break
        default: pool = CHARSETS.upper + CHARSETS.lower + CHARSETS.digits + CHARSETS.symbols
      }
      var results = []
      for (var n = 0; n < this.count; n++) {
        var str = ''
        for (var i = 0; i < this.length; i++) str += pool.charAt(Math.floor(Math.random() * pool.length))
        results.push(str)
      }
      this.outputs = results
    },
    copyOne:function(s){
      navigator.clipboard.writeText(s); this.$message.success(this.$t("common.status.copied"))
    },
    copyAll:function(){
      navigator.clipboard.writeText(this.outputs.join('\n')); this.$message.success(this.$t('tool.Generator.copiedAll'))
    },
    doAction:function(a){
      if (a === 'copy') this.copyAll()
      if (a === 'clear') this.outputs = []
    }
  }
}
</script>

<style scoped>
.gen-tool { width: 100%; }

.gen-input-section { margin-bottom: 24px; }
.gen-input-label { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #606266; margin-bottom: 16px; }
.gen-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; background: #4e7cff; box-shadow: 0 0 6px rgba(78,124,255,.4); }

.gen-row { margin-bottom: 14px; }
.gen-row-3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 16px; align-items: end; }

.gen-field { display: flex; flex-direction: column; gap: 6px; }
.gen-field label { font-size: 12px; font-weight: 600; color: #909399; }
.gen-field-length { gap: 8px; }

.gen-length-row { display: flex; align-items: center; gap: 12px; }
.gen-len-input { width: 140px; flex-shrink: 0; }
.gen-len-input >>> .el-input__inner { font-size: 15px; font-weight: 700; text-align: center; }
.gen-slider { flex: 1; margin: 0; }
.gen-hint { font-weight: 400; color: #c0c4cc; font-size: 11px; }
.gen-presets { display: flex; gap: 4px; flex-shrink: 0; }

.gen-output { background: #f8f9fb; border: 1px solid #e4e7ed; border-radius: 10px; overflow: hidden; }
.gen-output-bar { display: flex; align-items: center; justify-content: space-between; padding: 10px 16px; background: #eef1f6; border-bottom: 1px solid #e4e7ed; }
.gen-output-label { font-size: 12px; font-weight: 600; color: #606266; }
.gen-output-list { max-height: 520px; overflow: auto; }
.gen-output-row { display: flex; align-items: center; gap: 10px; padding: 8px 16px; border-bottom: 1px solid #f0f0f0; cursor: pointer; transition: background .12s; }
.gen-output-row:hover { background: #f0f4ff; }
.gen-output-num { font-size: 11px; color: #c0c4cc; min-width: 24px; text-align: right; flex-shrink: 0; }
.gen-output-text { flex: 1; font-size: 14px; font-family: 'Courier New',Consolas,monospace; color: #303133; word-break: break-all; user-select: all; }
.gen-copy-btn { flex-shrink: 0; opacity: 0; transition: opacity .12s; }
.gen-output-row:hover .gen-copy-btn { opacity: 1; }

.gen-empty { text-align: center; padding: 40px; color: #c0c4cc; font-size: 14px; }

@media (max-width: 640px) {
  .gen-length-row { flex-wrap: wrap; }
  .gen-len-input { width: 100%; }
  .gen-slider { flex: auto; min-width: 200px; }
  .gen-row-3 { grid-template-columns: 1fr 1fr; }
}
</style>
